import { TNavChartPeriods } from './InteractiveNavChart.types';

export const defaultPeriods: TNavChartPeriods = [
  {
    month: 0,
    title: 'از ابتدا',
    symbol: 'returnOverall',
  },
  {
    month: 1,
    title: '1 ماه',
    symbol: 'return1M',
  },
  {
    month: 3,
    title: '3 ماه',
    symbol: 'return3M',
  },
  {
    month: 12,
    title: '1 سال',
    symbol: 'return1Y',
  },
  {
    month: 5 * 12,
    title: '5 سال',
    symbol: 'return5Y',
  },
];
